import dayjs from "dayjs";

/**
 * Map API dropdown rows to react-select `{ value, label }`.
 * Supports `value`/`data`, `id`/`display` (e.g. HireStatus/options/incentive-status), and common aliases.
 */
export const mapCommonDropdownRecords = (records) =>
  (Array.isArray(records) ? records : [])
    .map((item) => {
      const value = String(
        item?.value ?? item?.id ?? item?._id ?? item?.key ?? item?.code ?? ""
      ).trim();
      const label = String(
        item?.display ??
          item?.label ??
          item?.data ??
          item?.name ??
          item?.title ??
          item?.text ??
          item?.value ??
          item?.id ??
          ""
      ).trim();
      if (!value) return null;
      return { value, label: label || value };
    })
    .filter(Boolean);

/**
 * Map `GET common/drug-status` `data[]` to react-select options.
 * Each row: `status` (display label), `value` (submitted as order status).
 */
export const mapDrugStatusApiRecordsToSelectOptions = (records) =>
  (Array.isArray(records) ? records : [])
    .map((drugStatusRow) => {
      const optionValue = String(drugStatusRow?.value ?? "").trim();
      if (!optionValue) return null;
      const displayLabel =
        String(drugStatusRow?.status ?? "").trim() || optionValue;
      return {
        value: optionValue,
        label: optionValue,
      };
    })
    .filter(Boolean);

export const HIRE_CLIENT_PAID_OPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Pending" },
  { value: "replacement", label: "Replacement" },
];

const normAcc = (accessor) =>
  String(accessor || "")
    .toLowerCase()
    .replace(/_/g, "");

/**
 * Which hire-status field this column maps to for inline edit (candidate-hire-status page only).
 * @returns {"dateHired"|"incentive"|"clientPaid"|"status"|"comments"|null}
 */
export const hireStatusInlineKind = (accessor) => {
  const n = normAcc(accessor);
  if (["datehired", "hireddate", "hiredate", "datehireddate"].includes(n)) return "dateHired";
  if (["incentivestatus", "incentivetype"].includes(n)) return "incentive";
  if (n === "clientpaid") return "clientPaid";
  if (n === "status" || n === "orderstatus") return "status";
  if (n === "comments" || n === "comment") return "comments";
  return null;
};

/** Draft for POST `HireStatus` — aligned with candidate-hire-status-add-edit-modal `buildFormFromRow`. */
export const deriveHireDraftFromRow = (item) => {
  const raw = item?._originalHireStatus ?? item;
  const id = String(raw?.id ?? raw?._id ?? "").trim();
  const dateRaw =
    raw?.dateHired ?? raw?.dateHiredDate ?? raw?.hiredDate ?? raw?.hireDate ?? "";
  let dateHired = "";
  if (dateRaw) {
    const d = dayjs(dateRaw);
    dateHired = d.isValid() ? d.format("YYYY-MM-DD") : String(dateRaw).slice(0, 10);
  }
  const clientPaidRaw = raw?.clientPaid;
  const clientPaid =
    clientPaidRaw === null || clientPaidRaw === undefined
      ? ""
      : String(clientPaidRaw).trim().toLowerCase();
  const incentiveStatus =
    raw?.incentiveStatus != null && raw?.incentiveStatus !== ""
      ? String(raw.incentiveStatus).trim()
      : raw?.incentiveStatusId != null && raw?.incentiveStatusId !== ""
        ? String(raw.incentiveStatusId).trim()
        : raw?.incentiveType != null && raw?.incentiveType !== ""
          ? String(raw.incentiveType).trim()
          : "";
  const status = String(raw?.status ?? raw?.orderStatus ?? "").trim();
  const comments = raw?.comments ?? raw?.comment ?? "";
  return { id, dateHired, incentiveStatus, clientPaid, status, comments };
};

export const hireUpdateSentForPayload = (raw = {}) => {
  const u = raw?.updateSent;
  if (u === true || u === "true" || u === 1 || u === "1") return true;
  if (u === false || u === "false" || u === 0 || u === "0") return false;
  return null;
};
